import { baseApi } from '../app/baseApi';

interface SendEmailResponse {
  success: boolean;
  message: string;
}

export const emailApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendEmail: builder.mutation<SendEmailResponse, string>({
      query: (meetingId) => {
        console.log( `meetings/sendEmailMeeting/${meetingId}`);
        return {
          url: `meetings/sendEmailMeeting/${meetingId}`,
          method: 'POST',
          credentials: 'include',
        };
      },
    
      async onQueryStarted(meetingId, { queryFulfilled }) {

        try {
          const { data } = await queryFulfilled;
          console.log("✅ השליחה הצליחה:", data);
        } catch (err) {
          console.error("❌ השליחה נכשלה:", err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useSendEmailMutation } = emailApi;
